import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class PressureSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.PressureSensor,
    });
  }
}
